export default {
  common: {
    title: 'Sistema ng Affiliate',
    logout: 'Mag-logout',
    changePassword: 'Palitan ang Password',
    login: 'Mag-login',
    signup: 'Mag-sign up',
    username: 'Username',
    loginnow: 'Mag-login Ngayon',
    password: 'Password',
    apply: 'Mag-apply',
    verificationcode: 'Verification Code',
    verification_title: 'Security Check, paki-click ang bawat hakbang:',
    verification_drag_title: 'Security Check, i-drag para ma-verify',
    verify_success: 'Matagumpay ang Verification',
    refresh: 'I-refresh',
    submit: 'Isumite',
    register_affi: 'Mag-register Ngayon',
    back_login: 'Bumalik sa Login',
    contact_us: 'Makipag-ugnayan sa Amin',
    affiliateaccountcanonlycontainnumchar:
      'Ang affiliate account ay maaari lamang maglaman ng underscore (_), numero, at letra.',
    confirmpassword: 'Kumpirmahin ang password.',
    affiliateaccount: 'Pangalan ng Affiliate Account',
    forgetpass: 'Nakalimutan ang Password.',
    zhuanshukefufuwu: 'Eksklusibong Customer Service',
    askus: 'Kahilingan',
    download: 'I-download',
    copy: 'Kopyahin',
    copied: 'Nakopya',
    email: 'Email',
    qq: 'QQ',
    skype: 'Skype',
    teams: 'Teams',
    paopao: 'Bubble',
    loofah: 'Loofah',
    zalo: 'Zalo',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    telegram_lk6: 'Telegram',
  },
  depositStatus: {
    SUCCESS: 'Matagumpay',
    SUPPLEMENT_SUCCESS: 'Matagumpay ang Supplement',
    CLOSED: 'Sarado',
    PENDING: 'Nakabinbin',
  },
  withdrawStatus: {
    ALL: 'Lahat',
    SUCCESS: 'Matagumpay',
    FAIL: 'Nabigo',
    APPLY: 'Nag-a-apply',
    STEP_1: 'Sinusuri',
    STEP_2: 'Babayaran',
    STEP_3: 'Kasalukuyang Binabayaran',
    AUTOPAY: 'Awtomatikong Bayad',
    PENDING: 'Nasuspinde',
    REJECT: 'Tanggihan',
    SENDING: 'Ipinapadala',
    WAITING_CALLBACK: 'Naghihintay ng Callback',
    PAYING: 'Nagbabayad',
    WAITING_AUTO_PAY: 'Naghihintay ng Awtomatikong Bayad',
    FAIL_REVIEW: 'Hindi naaprubahan',
  },
  withdrawConfirmStatus: {
    0: 'Hindi pa Kumpirmado',
    1: 'Natanggap na',
  },
  questions: {
    mothersName: "Ano ang pangalan ng iyong ina?",
    mothersBirthday: "Kailan ang kaarawan ng iyong ina?",
    dadsName: "Ano ang pangalan ng iyong ama?",
    dadsBirthday: "Kailan ang kaarawan ng iyong ama?",
    spouseBirthday: "Kailan ang kaarawan ng iyong asawa?",
    cityBorn: 'Saang lungsod ka ipinanganak?',
    highSchool: 'Saang high school ka nag-aral?',
    elementarySchool: 'Ano ang pangalan ng iyong elementary school?',
    firstPetName: 'Ano ang pangalan ng una mong alagang hayop?',
    firstCar: 'Ano ang brand ng una mong kotse?',
  },
  gameType: {
    SLOT: 'SLOT',
    LIVE: 'LIVE',
    FISH: 'FISH',
    SPORT: 'SPORT',
    ESPORT: 'ESPORT',
    POKER: 'POKER',
    LOTTERY: 'LOTTERY',
    MINIGAME: 'MINIGAME',
  },
  result: {
    WIN: 'PANALO',
    LOSS: 'TALO',
    DRAW: 'TABLA',
  },
  betStatus: {
    UNSETTLED: 'HINDI PA NA-SETTLE',
    SETTLED: 'NA-SETTLE',
    CANCEL: 'KANSELA',
  },
  transferType: {
    DEPOSIT: 'Ilipat mula sa Balanse',
    COMMISSION: 'Ilipat mula sa Balanse ng Komisyon',
  },
  creditFlowType: {
    Withdraw: 'Mag-withdraw',
    Transfer: 'Paglipat',
    Dividen: 'Dibidendo',
    Deposit: 'Deposito',
    Agent_Transfer: 'Paglipat ng Agent',
    Agent_Deposit: 'Deposito ng Agent',
    COMMISSION_WALLET_WITHDRAWAL: 'Mag-withdraw',
    COMMISSION_WALLET_AFFILIATE_DEPOSIT: 'Deposito ng Affiliate',
    COMMISSION_WALLET_SETTLEMENT: 'Settlement ng Komisyon',
    DEPOSIT_WALLET_DEPOSIT: 'Deposito',
    DEPOSIT_WALLET_AFFILIATE_DEPOSIT: 'Deposito ng Affiliate',
    DEPOSIT_WALLET_AMOUNT_ADJUST: 'Manual na Adjustment',
  },
  moneyChangeType: {
    TRANSFER: 'Paglipat',
    AFFILIATE_BET_REBATE: 'Rebate sa Pagtaya',
    DEPOSIT: 'Deposito',
    WITHDRAW: 'Pag-withdraw',
    ADJUST: 'Pagsasaayos',
    WITHDRAW_FAIL: 'Hindi Nagtagumpay ang Pag-withdraw',
    AFFILIATE_TRANSFER: 'Pagdeposito ng Ahente',
    AFFILIATE_RECEIVE: 'Pagtanggap ng Ahente',
  },
  moneyChangeSubType: {
    AFFILIATE_SETTLEMENT: 'Pag-settle ng Komisyon',
    AFFILIATE_DAILY_REBATE: 'Arawang Rebate sa Pagtaya',
    AFFILIATE_BIWEEKLY_SETTLEMENT: 'Pag-settle ng Lottery',
    AFFILIATE_MONTHLY_SETTLEMENT: 'Buwanang Pag-settle',
    COMMISSION: 'Komisyon',
  },
  settlementType: {
    'DAILY-LOTTERY': 'Araw-araw - Lottery',
    'DAILY-SPORT-LIVE-POKER': 'Araw-araw - Iba pa',
    'DAILY-SLOT': 'Araw-araw - Slot',
    DAILY: 'Araw-araw',
    LOTTERY: 'Lottery',
    MONTHLY: 'Buwanan',
  },
  referralLink: {
    affiliateWebPlatformLink: 'Affiliate Link ng PC Platform',
    affiliateH5PlatformLink: 'Affiliate Link ng H5 Platform (Inirerekomenda)',
    affiliateWXShortLink: 'Anti-block URL (Wechat)',
    affiliateQQShortLink: 'Anti-block URL (QQ)',
    affiliateZALOShortLink: 'Anti-block URL (Zalo)',
    affiliateLongLink: 'Karaniwang URL',
    affiliateWXQRLink: 'Anti-block QR Code (Wechat)',
    affiliateQQQRLink: 'Anti-block QR Code (QQ)',
    affiliateZALOQRLink: 'Anti-block QR Code (Zalo) ',
    affiliateLongQRLink: 'QR Code ng Karaniwang Link',
    affiliateDownloadQRtoLocal: 'I-download',
    affiliateScanMe: 'I-scan at Tingnan sa Mobile',
    copiedWXShortUrl: 'Matagumpay na nakopya ang Wechat anti-block URL',
    copiedQQShortUrl: 'Matagumpay na nakopya ang QQ anti-block URL',
    copiedZALOShortUrl: 'Matagumpay na nakopya ang Zalo anti-block URL',
    copiedLink: 'Matagumpay na Nakopya',
    downloadQRCode: 'I-download ang QR Code',
    affiliateShortLink: 'Maikling Domain',
  },
  commissionInfo: {
    commissionInfo: 'Impormasyon ng Komisyon',
    affiliateCommissionInfo: 'Impormasyon ng Komisyon ng Affiliate',
    commissionCalculator: 'Calculator ng Komisyon',
    monthlyTotalEffectiveTurnover: 'Kabuuang Bahagi ng Kita',
    pleaseInsertMonthlyTotalEffectiveTurnover:
      'Pakilagay ang kabuuang buwanang panalo/talo',
    monthlySettlement: 'Buwanang Settlement',
    pleaseInsertMonthlySettlement: 'Pakilagay ang buwanang settlement',
    monthlyDividen: 'Buwanang Bonus',
    pleaseInsertMonthlyDividen: 'Pakilagay ang buwanang bonus',
    platformFee: 'Bayad sa Platform',
    monthlyTotalDeposit: 'Kabuuang Buwanang Deposito ng Miyembro',
    pleaseInsertMonthlyTotalDeposit:
      'Pakilagay ang kabuuang buwanang deposito ng miyembro',
    monthlyTotalWithdrawal: 'Kabuuang Buwanang Withdrawal ng Miyembro',
    pleaseInsertMonthlyTotalWithdrawal:
      'Pakilagay ang buwanang withdrawal ng miyembro',
    totalCommissionAbleClaim: 'Kabuuang Buwanang Komisyon na Maaaring I-claim',
    calculate: 'Kalkulahin',
    commissionCalculatorNote:
      'Tandaan: Kinakalkula ng simulator batay sa average na rebate at tinatayang bonus, at ang venue selection ay default sa sitwasyong lahat ng miyembro ay naglalaro sa parehong venue. Ang resulta ay para sa sanggunian lamang.',
    commissionRateInfo: 'Impormasyon ng Rate ng Komisyon',
    commissionRateDescription:
      'Ang rate ng komisyon ng affiliate ay nakabatay sa buwanang panalo/talo at bilang ng active member; kapag natugunan ang dalawang kondisyon, makukuha ng affiliate ang kaukulang rate ng komisyon.',
    activeMemberRequirement:
      'Bilang ng active members: deposito sa buwan >= 100 o valid bet >= 500;',
    activeMemberRequirementDescription:
      '(Kinakailangan: Magdagdag ng active members at matugunan ang mga kondisyon upang maipamahagi ang komisyon nang proporsyonal.)',
    level: 'Antas',
    affiliateType: 'Affiliate',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    diamond: 'Diamond',
    crown: 'Crown',
    companyMonthlyProfit: 'Kita',
    activeNumberRequirement: 'Active Members',
    commissionRate: 'Rate ng Komisyon',
    commissionCalculateFormula: 'Pagkalkula ng Komisyon',
    commissionFormula:
      'Komisyon = Netong Kita Pagkatapos ng Correction * Rate ng Komisyon + Adjustment sa Komisyon + Supplement sa Komisyon; ',
    correctionNetProfitFormula:
      'Netong Kita Pagkatapos ng Correction = Buwanang Netong Kita + Balanse noong Nakaraang Buwan; ',
    monthlyNetProfitFormula:
      'Buwanang Netong Kita = Kabuuang Buwanang Panalo/Talo - Bonus - Rebate - Bayad sa Platform - Adjustment sa Account + Supplement Win/Loss - Processing Fee sa Deposit/Withdrawal; ',
    bonusFormula:
      'Bonus = Kabuuang halaga ng bonus na natanggap ng downline ng affiliate sa kasalukuyang buwan; ',
    rebateFormula:
      'Rebate = Kabuuang halaga ng rebate na natanggap ng downline ng affiliate sa kasalukuyang buwan; ',
    platformFeeFormula:
      'Bayad sa Platform = Kabuuang Panalo/Talo ng bawat platform * Rate ng Bayad sa Platform; sisingilin lang ito kapag may kita sa buwang iyon; ',
    adjustmentFormula:
      'Adjustment sa account = Kapag abnormal ang rollover ng miyembro, gagawa ang site admin ng adjustment sa account ng miyembro;',
    supplementWinLossFormula:
      'Supplement Win/Loss = Netong kita ng real-time data noong nakaraang buwan - netong kita ng komisyong naipamahagi noong nakaraang buwan; ',
    depositFeeFormula:
      'Bayad sa Deposito = Halaga ng Deposito ng Downline * Rate ng Bayad sa Deposito + Halaga ng Deposito ng Affiliate * Rate ng Bayad sa Deposito; ',
    withdrawalFeeFormula:
      'Bayad sa Withdrawal = Halaga ng Withdrawal ng Downline * Rate ng Bayad sa Withdrawal; ',
    commissionAdjustmentNote:
      'Supplement sa Komisyon: Pagkatapos ma-release ang komisyon para sa buwan, gagawin ang supplement batay sa mga kaugnay na aktibidad na sinalihan ng affiliate. ',
    commissionNote:
      'Tandaan: Ang sinumang gagamit ng hindi tapat na paraan upang mandaya sa komisyon ay permanenteng ifi-freeze ang account at tatapusin ang partnership. Hindi babayaran ang lahat ng komisyon. ',
    newAgentSupport: "Suporta para sa Bagong Ahente",
    noRequirements: "Walang kinakailangang kondisyon",
    lk6: {
      model1: 'Modelo 1',
      turnoverCommissionDesc:
        'Modelong agent na hindi revenue share. Nag-aalok ang Lucky6 ng malaking turnover commissions.',
      fixedProfitPercentageEarningDesc:
        'Hindi kailangang mag-alala sa panalo o talo ng client. Kumita ng fixed profit ayon sa porsyento!',
      tableHeader1: 'Active Users',
      tableHeader2: 'Lingguhang Turnover',
      tableHeader3: 'Rate ng Komisyon',
      oneMillionPlus: '1 milyon+',
      twentyMillionPlus: '20 milyon+',
      model1Example:
        'Halimbawa: Kung ang offline members ay may kabuuang valid turnover na 1,600,000 ngayong linggo, 1,600,000 x 0.4% = 6400U, at kikita ka ng 6400U na komisyon.',
      commisionAdjustment: 'Maaaring i-adjust buwan-buwan ang rates ng komisyon.',
      commissionQualifyRule1:
        'Para maging qualified sa komisyon, dapat mayroon kang hindi bababa sa 5 active users bawat buwan. Kapag hindi natugunan, hindi maaaring i-claim ang komisyon.',
      commissionQualifyRule2:
        'Kahulugan ng active user: lingguhang deposito na 1000 o valid bet na 1000.',
      contactInfo:
        'Para sa detalyadong rules at terms, makipag-ugnayan sa affiliate representative sa Telegram: @xy66vip.',
      model2: 'Modelo 2',
      commissionBasedAgentModel: 'Revenue Share Agent Model — Up to 90% Share',
      commissionBasedAgentModelDesc:
        'May ibinibigay na credit line, at ang komisyon ay hinahati sa kumpanya batay sa napagkasunduang porsyento. Responsable ang agent sa pamamahala ng deposits at withdrawals ng mga miyembro. Maaari mong gamitin ang sarili mong domain o humiling ng dedicated agent domain mula sa kumpanya. Ang rebates at win/loss settlements ay pinangangasiwaan ng agent. Nakikipag-settle ang kumpanya batay sa 0.8% turnover share.',
      model3: 'Modelo 3',
      threeLevelAgentModel: 'Three-Level Agent Model',
      threeLevelAgentModelDesc:
        'Lingguhang ina-settle ang komisyon ng agent. Kumita ng 0.3% ng turnover ng direktang miyembro, 0.15% ng kabuuang turnover ng iyong direktang agent (kasama ang kanilang mga miyembro at agent), at 0.05% ng kabuuang turnover ng mga sub-agent ng iyong direktang agent.',
      example: 'Halimbawa:',
      threeLevelAgentModelExample:
        'Ngayong linggo: ang iyong direktang miyembro ay bumubuo ng 1 milyong turnover, ang direktang agent ay 3 milyon, at ang kanilang mga sub-agent ay 2 milyon. Ang iyong komisyon: 1M × 0.3% = 3000U, 3M × 0.15% = 4500U, 2M × 0.05% = 1000U. Kabuuan = 8500U.',
      chooseOneModel:
        'Maaari ka lamang pumili ng isa sa tatlong modelo sa itaas. Kontakin ang aming Telegram affiliate manager @xy66vip para matuto pa!',
    },
  },
  sortType: {
    ASC: 'PATAAS',
    DESC: 'PABABA',
  },
  rebateStatus: {
    PENDING: 'NAKABINBIN',
    IN_PROGRESS: 'IN PROGRESS',
    DISTRIBUTED: 'NAIPAMAHAGI',
    CANCEL: 'KANSELA',
  },
  fields: {
    filters: 'Mga Filter',
    account: 'Account',
    accountInfo: 'Impormasyon ng Account',
    activeMember: 'Active Member',
    activePlayer: 'Active Player',
    activeUsers: 'Active Users',
    add: 'Magdagdag',
    addBankCard: 'Magdagdag ng Bank Card',
    addVirtualCard: 'Magdagdag ng Virtual Card',
    adjust: 'I-adjust',
    adjustAmount: 'Halaga ng Adjustment',
    adjustment: 'Adjustment',
    adjustReason: 'Dahilan ng Adjustment',
    adjustType: 'Uri ng Adjustment',
    affiliate: 'Affiliate',
    affiliateAccount: 'Affiliate Account',
    affiliateCode: 'Affiliate Code',
    affiliateDeposit: 'Deposito',
    affiliateInfo: 'Impormasyon ng Affiliate',
    affiliateLevel: 'Antas ng Affiliate',
    affiliateStatus: 'Status ng Affiliate',
    affiliateWithdraw: 'Bank Withdrawal',
    affiliateWithdrawRecord: 'Record ng Bank Withdrawal',
    amount: 'Halaga',
    amountOfFirstDeposit: 'Halaga ng Unang Deposito',
    answerOne: 'Sagot Isa',
    answerTwo: 'Sagot Dalawa',
    answerThree: 'Sagot Tatlo',
    answerSecurityQuestion: 'Sagutin ang Lahat ng Security Question',
    appLink: 'Link sa Pag-download ng Application',
    balance: 'Balanse',
    bank: 'Bangko',
    bankCard: 'Bank Card',
    bankId: 'Bank ID',
    bankName: 'Pangalan ng Bangko',
    bankCode: 'Bank Code',
    bet: 'Taya',
    betMembers: 'Mga Miyembrong Tumaya',
    betRecord: 'Record ng Taya',
    betRecordDetails: 'Detalye ng Record ng Taya',
    betTime: 'Oras ng Taya',
    bind: 'I-bind',
    bindAccountList: 'Listahan ng Bound Accounts',
    bindBankCardList: 'Listahan ng Bound Bank Cards',
    bindCryptoList: 'Listahan ng Bound Crypto',
    binded: 'Naka-bind',
    bindEWalletList: 'Listahan ng Bound E-Wallet',
    bindSecurityQn: 'I-set up ang Security Question',
    bindWithdrawPw: 'I-set up ang Withdraw Password',
    bonus: 'Bonus',
    bulk_read: 'Bulk Read',
    bulk_delete: 'Bulk Delete',
    cancel: 'Kanselahin',
    cardAccount: 'Card Account',
    cardAddress: 'Card Address',
    cardNumber: 'Card Number',
    changeWithdrawPw: 'Palitan ang Withdraw Password',
    clearingSum: 'Clearing Sum',
    commission: 'Komisyon',
    gamecommission: 'Komisyon ng Platform',
    commissionBalance: 'Balanse ng Komisyon',
    commissionPercent: 'Porsyento ng Komisyon',
    commissionRate: 'Rate ng Komisyon',
    commissionReport: 'Ulat ng Komisyon',
    commissionTransfer: 'Paglipat ng Komisyon',
    commissionWallet: 'Commission Wallet',
    companyProfit: 'Kita ng Kumpanya',
    confirm: 'Kumpirmahin',
    confirmNewPassword: 'Kumpirmahin ang Bagong Password',
    confirmWithdraw: 'Kumpirmahin ang Withdrawal',
    copy: 'Kopyahin',
    createAffiliate: 'Gumawa ng Affiliate',
    createTime: 'Oras ng Paglikha',
    creditFlow: 'Daloy ng Credit',
    creditFlowAmount: 'Halaga ng Credit Flow',
    creditFlowId: 'ID',
    creditFlowType: 'Uri ng Credit Flow',
    creditFlowDate: 'Petsa ng Credit Flow',
    creditFlowBalance: 'Balanse ng Credit Flow',
    crypto: 'Crypto',
    currentPassword: 'Kasalukuyang Password',
    deduct: 'Ibawas',
    deposit: 'Deposito',
    depositAmount: 'Halaga ng Deposito',
    depositBettingAmount: 'Deposito/Taya',
    depositCount: 'Bilang ng Deposito',
    depositDate: 'Petsa ng Deposito',
    depositRecord: 'Record ng Deposito',
    depositUsers: 'Mga User na Nagdeposito',
    depositWallet: 'Deposit Wallet',
    domainAffiliate: 'Affiliate Domain',
    domainApp: 'PC Domain',
    domainWeb: 'Mobile Domain',
    downlineAffiliate: 'Downline Affiliate',
    downlineCommission: 'Downline Commission',
    downlineCommissionRate: 'Rate ng Downline Commission',
    downlineMember: 'Downline Member',
    downlineProfit: 'Kita ng Downline',
    download: 'I-download',
    edit: 'I-edit',
    editAffiliate: 'I-edit ang Affiliate',
    editRealName: 'I-update ang Tunay na Pangalan',
    email: 'Email',
    endDate: 'Petsa ng Pagtatapos',
    enquire: 'Magtanong',
    enterTheWithdrawalAmount: 'Ilagay ang halaga ng withdrawal',
    estimatedAffiliateCommission: 'Tinatayang Komisyon ng Affiliate',
    estimatedMemberCommission: 'Tinatayang Komisyon ng Miyembro',
    ewallet: 'e-Wallet',
    ewalletNumberHint: 'Please enter a number starting with 0',
    eventClickCount: 'Mga Click sa Page',
    finalSum: 'Panghuling Kabuuan',
    finishDate: 'Petsa ng Pagtatapos',
    firstDepositAmount: 'Halaga ng Unang Deposito',
    firstDepositUsers: 'Mga User na Unang Nagdeposito',
    ftd: 'Unang Deposito',
    gameName: 'Pangalan ng Laro',
    gameType: 'Uri ng Laro',
    lastLoginTime: 'Huling Oras ng Login',
    lastMonth: 'Nakaraang Buwan',
    lastMonthTotal: 'Kabuuan noong Nakaraang Buwan',
    lastWeek: 'Nakaraang Linggo',
    link: 'Link ng Imbitasyon',
    loginName: 'Login Name',
    loginPassword: 'Password',
    member: 'Miyembro',
    memberBetRecords: 'Mga Record ng Taya ng Miyembro',
    memberCommission: 'Komisyon ng Miyembro',
    memberProfitDownlineProfitUnsettleCommission:
      'Kita ng Miyembro / Kita ng Downline / Hindi pa Na-settle na Komisyon',
    memberInfo: 'Impormasyon ng Miyembro',
    memberType: 'Uri ng Miyembro',
    minActiveMemberCount: 'Minimum na Bilang ng Active Member',
    month: 'Buwan',
    monthlyAffiliateCommission: 'Buwanang Komisyon ng Affiliate',
    monthBeforeLastTotal: 'Kabuuan ng Buwan Bago ang Nakaraan',
    monthlyMemberCommission: 'Buwanang Komisyon ng Miyembro',
    newMemberCount: 'Bilang ng Bagong Miyembro',
    newMember: 'Bagong Rehistradong Miyembro',
    activeMemberCount: 'Bilang ng Active Member',
    totalRegisterCount: 'Kabuuang Bilang ng Rehistro',
    myAccount: 'Aking Account',
    realName: 'Tunay na Pangalan',
    name: 'Pangalan',
    netProfit: 'Netong Kita',
    newPassword: 'Bagong Password',
    newUsers: 'Bagong Users',
    ngr: 'NGR',
    noData: 'Walang Data',
    actions: 'Mga Aksyon',
    operate: 'Operasyon',
    operationalData: 'Datos ng Operasyon',
    password: 'Password',
    paymentFee: 'Bayad sa Payment',
    paymentMethod: 'Paraan ng Payment',
    paymentName: 'Pangalan ng Payment',
    payout: 'Payout',
    personal: 'Personal',
    personalInfo: 'Personal na Impormasyon',
    privilegeSerialNumber: 'Serial Number',
    privilegeRecord: 'Mga Record ng Pribilehiyo',
    privilegeName: 'Pangalan ng Pribilehiyo',
    platform: 'Platform',
    platformFee: 'Bayad sa Platform',
    profit: 'Kita',
    questionOne: 'Tanong Isa',
    questionTwo: 'Tanong Dalawa',
    questionThree: 'Tanong Tatlo',
    readed: 'Nabasa',
    rebate: 'Rebate',
    recordTime: 'Oras ng Record',
    reenterPassword: 'Ilagay muli ang Password',
    referralCode: 'Referral Code',
    referralLink: 'Referral Link',
    regenerate: 'Bumuo Muli',
    registerTime: 'Oras ng Pagrehistro',
    reset: 'I-reset',
    result: 'Resulta',
    revenueShare: 'Revenue Share',
    revenueShareRate: 'Rate ng Revenue Share',
    rollover: 'Rollover Multiplier',
    search: 'Maghanap',
    secondLevelAffiliateCommission: 'Komisyon ng Second Level Affiliate',
    securityInfo: 'Impormasyon sa Seguridad',
    securityQuestion: 'Security Question',
    select: 'Pumili',
    selectACard: 'Pumili ng card',
    selectBank: 'Pumili ng bangko',
    selectBankCard: 'Pumili ng bank card',
    selectUsdtWallet: 'Pumili ng USDT wallet',
    serialNumber: 'Serial Number',
    paymentType: 'Uri ng Payment',
    settleTime: 'Oras ng Settlement',
    settleView: 'Tingnan',
    settlePay: 'Bayaran',
    settleEdit: 'I-edit',
    site: 'Site',
    startDate: 'Petsa ng Simula',
    status: 'Status',
    subtotal: 'Subtotal',
    systemAlert: 'System Alert',
    affiliateSuccessSubmit:
      'Minamahal naming partner, matagumpay na naisumite ang iyong impormasyon. Ipapaalam sa iyo ng aming agent ang resulta ng review sa loob ng 24 oras. Kung may tanong ka, makipag-ugnayan sa aming agent o online customer service. Salamat.',
    affiliateSuccessSubmitPh2:
      'Dear Partner,\nYour agent application has been submitted successfully. Please contact our online customer service promptly and provide your agent account so our staff can review and approve your application as soon as possible.\nThank you for your support and cooperation!',
    onlineCustomerService: 'Online Customer Service',
    onlineCustomerServiceTip:
      'Please provide your agent account when contacting us so we can process your approval.',
    systemAnnouncement: 'Anunsyo ng Sistema',
    telephone: 'Telepono',
    thirdLevelAffiliateCommission: 'Komisyon ng Third Level Affiliate',
    thisYear: 'Ngayong Taon',
    thisThreeMonths: 'Tatlong Buwan',
    thisMonth: 'Ngayong Buwan',
    thisPeriod: 'Kasalukuyang Panahon',
    lastPeriod: 'Nakaraang Panahon',
    thisWeek: 'Ngayong Linggo',
    title: 'Pamagat',
    today: 'Ngayon',
    totalBet: 'Kabuuang Taya',
    totalCompanyProfit: 'Kabuuang Kita ng Kumpanya',
    totalCommissionProfit: 'Kabuuang Kita sa Komisyon',
    totalCommission: 'Kabuuang Komisyon',
    totalDeposit: 'Kabuuang Deposito',
    totalDownlineAffiliate: 'Kabuuang Downline Affiliate',
    totalDownlineMember: 'Kabuuang Downline Member',
    totalPayout: 'Kabuuang Payout',
    totalTransfer: 'Kabuuang Paglipat',
    totalWithdraw: 'Kabuuang Withdrawal',
    transactionId: 'Transaction ID',
    transfer: 'Paglipat',
    transferAmount: 'Halaga ng Paglipat',
    transferDate: 'Petsa ng Paglipat',
    transferIn: 'Transfer In',
    transferOut: 'Transfer Out',
    transferRecord: 'Record ng Paglipat',
    transferType: 'Uri ng Paglipat',
    transferUsers: 'Mga User ng Paglipat',
    unread: 'Hindi pa Nabasa',
    upperName: 'Pangalan ng Upline',
    usdtWallet: 'USDT Wallet',
    usdtWalletAddress: 'USDT Wallet Address',
    unsettleCommission: 'Hindi pa Na-settle na Komisyon',
    updateBy: 'In-update Ni',
    viewDetails: 'Tingnan ang Detalye',
    vipLevel: 'VIP Level',
    visitsNo: 'Bilang ng Pagbisita',
    winLoss: 'Panalo/Talo',
    withdraw: 'Mag-withdraw',
    withdrawAmount: 'Halaga ng Withdrawal',
    withdrawCount: 'Bilang ng Withdrawal',
    withdrawPassword: 'Withdraw Password',
    withdrawPayoutBonus: 'Adjustment sa Withdraw Payout Bonus',
    withdrawalAmount: 'Halaga ng Withdrawal',
    yesterday: 'Kahapon',
    memberTag: 'Tag ng Miyembro',
    memberTagDescription: 'Pakilagay ang description sa loob ng 10 character',
    tagSetting: 'Setting ng Tag',
    createTag: 'Gumawa ng Tag',
    editTag: 'I-edit ang Tag',
    memberAmount: 'Halaga ng Miyembro',
    delete: 'Tanggalin',
    sequence: 'S/N',
    back: 'Bumalik',
    all: 'Lahat',
    yes: 'Oo',
    no: 'Hindi',
    more: 'Higit pa',
    remark: 'Remark ng Miyembro',
    bonusRecord: 'Record ng Bonus',
    ftdTime: 'Oras ng Unang Deposito',
    validBet: 'Valid Bet',
    unAssigned: 'Hindi Naka-assign',
    batchEditTag: 'Batch Edit ng Tag',
    personalReport: 'Personal na Ulat',
    platformFeePercentage: 'Porsyento ng Bayad',
    rolloverAmount: 'Rollover',
    privilegeType: 'Uri ng Pribilehiyo',
    personalCommission: 'Personal na Komisyon',
    payTime: 'Oras ng Bayad',
    payStatus: 'Status ng Bayad',
    accountAdjustment: 'Adjustment sa Account',
    commissionAdjustment: 'Adjustment sa Komisyon',
    image: 'Larawan',
    imageTitle: 'Pamagat ng Larawan',
    imageType: 'Uri ng Larawan',
    uploadTime: 'Oras ng Upload',
    imageSize: 'Laki ng Larawan',
    downloadTime: 'Bilang ng Download',
    generateQR: 'Gumawa ng QR Code',
    qrCode: 'QR Code',
    textInfo: 'Impormasyon ng Text',
    qrCodeColor: 'Kulay ng QR Code',
    qrCodeBgColor: 'Kulay ng Background ng QR Code',
    qrCodeLink: 'Link ng QR Code',
    qrCodePreview: 'Preview ng QR Code',
    text: 'Text',
    textColor: 'Kulay ng Text',
    textBgColor: 'Kulay ng Background ng Text',
    textPreview: 'Preview ng Text',
    preview: 'Preview',
    custom: 'Custom',
    packHistory: 'History ng Pack',
    packType: 'Uri ng Pack',
    selectSystem: 'Pumili ng System',
    appVersion: 'Bersyon ng App',
    appName: 'Pangalan ng App',
    appIcon: 'Icon ng App',
    packNow: 'I-pack Ngayon',
    upload: 'I-upload',
    packDate: 'Petsa ng Pack',
    osType: 'Uri ng System',
    buildStatus: 'Status ng Build',
    apkType: 'Uri ng APK',
    normal: 'Normal',
    newKey: 'Antivirus',
    detail: 'Detalye',
    packSize: 'Laki ng Pack',
    packDownloadUrl: 'URL ng Download ng Channel Pack',
    unchanged: 'Hindi Nagbago',
    unbind: 'I-unbind',
    depositWithdrawalProfit: 'Kita sa Deposit/Withdrawal',
    registerCount: 'Bilang ng Rehistro',
    ftdCount: 'Bilang ng FTD',
    ftdAmount: 'Halaga ng FTD',
    indBet: 'Taya',
    indProfit: 'Kita',
    last3Months: 'Huling 3 Buwan',
    total: 'Kabuuan',
    betAmount: 'Halaga ng Taya',
    payoutAmount: 'Halaga ng Payout',
    totalMemberDepositAmount: 'Kabuuang Halaga ng Deposito ng Miyembro',
    totalMemberDepositCount: 'Kabuuang Bilang ng Deposito ng Miyembro',
    bonusAmount: 'Halaga ng Bonus',
    rebateAmount: 'Halaga ng Rebate',
    indBonusAmount: 'Halaga ng Bonus',
    indRebateAmount: 'Halaga ng Rebate',
    indAdjustAmount: 'Halaga ng Adjustment',
    grossProfit: 'Gross Profit',
    totalBetMemberCount: 'Kabuuang Bilang ng Taya ng Miyembro',
    totalDepositMemberCount: 'Kabuuang Bilang ng Deposito ng Miyembro',
    orderBy: 'Ayusin Ayon Sa',
    sortType: 'Uri ng Sort',
    exclusiveDomain: 'Eksklusibong Domain Name',
    pcWay: 'PC',
    mobileWay: 'Mobile',
    forgetPassword: 'Nakalimutan ang Password',
    authenticator: 'Authenticator',
    createMember: 'Gumawa ng Miyembro',
    shareRatio: 'Share Ratio',
    rebateWallet: 'Rebate Wallet',
    affiliateTotalRebate: 'Rebate ng Affiliate',
    myRebate: 'Aking Rebate',
    totalWinLoss: 'Kabuuang Panalo/Talo',
    todayDeposit: 'Deposito Ngayon',
    todayWithdrawal: 'Withdrawal Ngayon',
    depositWithdrawalDiff: 'Pagkakaiba ng Deposit at Withdrawal',
    recommenderCode: 'Recommender Code',
    memberShareRatio: 'Share Ratio ng Miyembro',
    editShareRatio: 'I-edit ang Share Ratio',
    alipay: 'Alipay',
    alipayAcc: 'Alipay Account',
    typeWallet: '{walletType} Wallet',
    vietnamese: 'Tiếng Anh',
    english: 'Ingles',
    chinese: '中文',
    affiliateName: 'Pangalan ng Affiliate',
    ftdAmountAndMemberCount: 'Halaga ng FTD / Bilang ng Miyembro',
    depositAmountAndMemberCount: 'Halaga ng Deposito / Bilang ng Miyembro',
    withdrawAmountAndMemberCount: 'Halaga ng Withdrawal / Bilang ng Miyembro',
    reloadAmountAndMemberCount: 'Halaga ng Reload / Bilang ng Miyembro',
    reloadRate: 'Rate ng Reload',
    retention1d: 'Retention 1D',
    retention2d: 'Retention 2D',
    retention3d: 'Retention 3D',
    retention4d: 'Retention 4D',
    retention5d: 'Retention 5D',
    retention6d: 'Retention 6D',
    retention7d: 'Retention 7D',
    retention8d: 'Retention 8D',
    retention9d: 'Retention 9D',
    retention10d: 'Retention 10D',
    retention14d: 'Retention 14D',
    retention30d: 'Retention 30D',
    retentionDay1: 'Day2',
    retentionDay2: 'Day3',
    retentionDay3: 'Day4',
    retentionDay4: 'Day5',
    retentionDay5: 'Day6',
    retentionDay6: 'Day7',
    retentionDay7: 'Day8',
    retentionDay14: 'Day15',
    retentionDay30: 'Day31',
    depositRetention: 'Retention ng Deposito',
    regLoginRetention: 'Retention ng Login',
    totalProfit: 'Kabuuang Kita',
    monthlyCommissionData: 'Data ng Komisyon Ngayong Buwan',
    lotteryCommissionData: 'Loterya Data ng Komisyon Sa Panahong Ito',
    othersCommissionData: 'Iba Pa Data ng Komisyon Sa Panahong Ito',
    estimatedTeamCommission: 'Tinatayang Kita ng Koponan',
    estimatedDownlineCommission: 'Tinatayang Kita ng Mga Downline',
    lottery: 'Loterya',
    others: 'Iba Pa',
    creditFlowSubType: 'Subtype',
    beforeBalance: 'Dating Balanse',
    afterBalance: 'Bagong Balanse',
    targetName: 'Pangalan ng Target',
    settlementType: 'Uri ng Pag-settle',
    downlineRebate: 'Rebate ng Downline',
    walletBalance: 'Balanse ng Wallet',
    newAffiliateCount: 'Bilang ng Bagong Affiliate',
  },
  google: {
    google_auth_menu: 'Google Authenticator',
    download_install: 'I-download ang App',
    add_key: 'Magdagdag ng Security Key',
    bind_verify: 'I-bind ang Google Auth',
    popup_title: 'Google Authenticator',
    popup_msg:
      "Ang Google Authenticator ay dynamic password tool na awtomatikong nagre-refresh bawat 30 segundo. Kapag nagsasagawa ng sensitibong aksyon gaya ng paglipat ng pondo, withdrawal, o pag-aayos ng security settings sa backend ng proxy, kailangan mong ilagay ang 6-digit identity verification code na ito para sa authentication.",
    popup_hint:
      'Dapat gamitin ang identity authenticator kasama ng proxy account.',
    i_know: 'Alam Ko',
    download_way: 'Paraan ng Pag-download:',
    download_through_way: '1. Sa Download Link:',
    ios_download: 'I-download sa iOS',
    android_download: 'I-download sa Android',
    ios_scan_download: 'I-scan para I-download sa iOS',
    android_scan_download: 'I-scan para I-download sa Android',
    if_cannot_download_you_can:
      '2. Kung hindi mo ito ma-download, maaari mo itong hanapin sa Apple App Store."',
    or_search_in_google: '", o hanapin sa Android App Store.',
    download_and_install: '" para i-download at i-install.',
    next_step: 'Susunod',
    keyin_pass: 'Ilagay ang Password at Susunod',
    keyin_your_password: 'Ilagay ang Login Password',
    tips_installed:
      'Quick tip: Kapag na-download at na-install na, i-click lang ang "Susunod" upang magpatuloy.',
    qr_code: 'QR Code',
    secret_key: 'Secret Key',
    add_step: 'Mga Hakbang sa Pagdagdag',
    add_step_desc:
      'Buksan ang Google Authenticator, i-click ang "+" sa kanang ibabang sulok, piliin ang "Manually enter the key," at maglagay ng anumang account upang i-bind ito sa nabanggit na secret key. (Awtomatikong maidaragdag ito kapag ni-scan ang QR code.)',
    check_example: 'Tingnan ang Halimbawa',
    back: 'Bumalik',
    small_tips: 'Quick tip:',
    small_tips_info_1:
      '1. Kung mawala ang iyong phone o ma-uninstall ang authentication app, makakatulong ang key para ma-recover ang authenticator. Itago ito nang maayos.',
    small_tips_info_2:
      '2. Para sa seguridad ng iyong account, huwag markahan ang proxy account at proxy backend address habang nagbi-bind.',
    keyin_6_digit_google: 'Pakilagay ang 6-digit Google Auth Code.',
    auth_code: 'Google Authenticator',
    bind_now: 'I-bind Ngayon',
    please_enter_password: 'Pakilagay ang iyong password',
    added_success: 'Matagumpay na naidagdag ang Google Authenticator code',
    if_not_google_auth_then:
      "Kung hindi mo pa na-bind ang Google Authenticator, hindi mo kailangang punan ito.",
    google_auth_code: 'Ilagay ang 6-digit Google Authenticator Code',
  },
  forgetPassword: {
    verifyAuth: 'Authentication',
    verifyQues: 'Security Question',
    resetPassword: 'Reset Password',
    verify: 'Verify',
    submit: 'Isumite',
    reset: 'I-reset',
    answer: 'Answer',
    messageAuth: 'Pakilagay ang login name at Google authentication code',
    messageQues: 'Pakisagot ang sumusunod na security question',
    messageReset: 'Pakisreset ang iyong password',
    noSecurityQuestionSet:
      'Walang naka-set up na security question ang account na ito, makipag-ugnayan sa customer support',
    resetSuccess: 'Matagumpay na na-reset ang password',
  },
  message: {
    adjustSuccess: 'Matagumpay ang Adjustment',
    addSuccess: 'Matagumpay na Nadagdag',
    bindBankCard: 'I-bind muna ang bank card',
    bindWalletType: 'I-bind muna ang {walletType}',
    bindUsdtWallet: 'I-bind muna ang USDT wallet',
    chineseCharacters: 'Pakilagay ang Chinese characters',
    commissionPaySuccess: 'Matagumpay ang Bayad sa Komisyon',
    confirmToAdjust:
      'Sigurado ka bang gagawa ng adjustment? Hindi na makakagawa ng ibang adjustment pagkatapos kumpirmahin.',
    confirmToPay: 'Kumpirmahin na gusto mong magpatuloy sa payment?',
    deleteSuccess: 'Matagumpay na Natanggal',
    domainAppCopied: 'Nakopya ang Web Domain sa clipboard.',
    domainWebCopied: 'Nakopya ang App Domain sa clipboard.',
    editSuccess: 'Matagumpay na Na-edit',
    inputRealName: 'Hindi pa naka-set ang tunay na pangalan ng miyembro',
    emailFormat: 'Pakilagay ang tamang format ng email address',
    inputChineseCharacters: 'Pakilagay ang Chinese characters',
    inputDigits: 'Pakilagay ang mga digit',
    inputPassword: 'Pakilagay ang password',
    inputPasswordAgain: 'Pakilagay muli ang password',
    length6To12: 'Ang haba ay dapat 6 hanggang 12',
    lengthShouldBe: 'Ang haba ay dapat ',
    passwordLength:
      'Ang password ay hindi dapat mas mababa sa 6 digit o higit sa 12 digit',
    redirectBankDeposit:
      'Na-redirect ka sa iyong bangko para ipagpatuloy ang deposito. Kapag matagumpay ang deposito, makikita ito dito.',
    reenterPassword: 'Pakilagay muli ang password',
    referralLinkCopied: 'Nakopya ang referral link sa clipboard.',
    remaining: 'Natitira',
    requiredAffiliateLevel: 'Kailangan ang antas ng affiliate',
    required_signup_account: 'Hindi maaaring walang laman ang agency account.',
    required_6_to_12: 'Dapat binubuo ng 6-12 digit o letra.',
    requried_password: 'Hindi maaaring walang laman ang login password.',
    required_captcha: 'Hindi maaaring walang laman ang verification code.',
    required_4_digits: 'Dapat binubuo ng 4 na digit.',
    required_confirm_pwd: 'Hindi maaaring walang laman ang kumpirmasyon ng password.',
    required_same_with_password: 'Dapat kapareho ng login password.',
    requiredAmount: 'Kailangan ang halaga',
    requiredAnswer: 'Kailangan ang sagot',
    requiredCardAccount: 'Kailangan ang card account',
    requiredCardAddress: 'Kailangan ang card address',
    requiredCardNumber: 'Pakilagay ang bank card number',
    requiredCommission: 'Kailangan ang komisyon',
    requiredEmail: 'Kailangan ang email',
    requiredLoginName: 'Kailangan ang login name',
    requiredMemberType: 'Piliin ang uri ng miyembro.',
    requiredOldPassword: 'Kailangan ang kasalukuyang password',
    requiredPassword: 'Kailangan ang password',
    requiredRealName: 'Kailangan ang tunay na pangalan',
    requiredRevenueShare: 'Kailangan ang revenue share',
    requiredRollover: 'Kailangan ang rollover',
    requiredTelephone: 'Kailangan ang telepono',
    requiredTransferAmount: 'Kailangan ang halaga ng paglipat',
    requiredUsdtWallet: 'Pakilagay ang USDT wallet',
    requiredEwallet: 'Pakilagay ang e-Wallet number',
    requiredUserName: 'Kailangan ang user name',
    requiredWithdrawPassword: 'Kailangan ang withdraw password',
    selectAQuestion: 'Pumili ng tanong',
    selectBankCard: 'Paki select a bank card',
    selectUsdtWallet: 'Pumili ng USDT wallet',
    setSecurityQn: 'I-set up ang security question',
    setSecAndPw: 'I-set up ang security question at withdraw password',
    setWithdrawPassword: 'I-set up ang withdraw password',
    singleLimit: 'Single Limit',
    success: 'Matagumpay',
    times: 'beses',
    twoPasswordNotMatch: 'Hindi magkatugma ang dalawang password',
    unbindConfirm: 'Sigurado ka bang gusto mong i-unbind ',
    validateAdjustAmountRequired: 'Kailangan ang halaga ng adjustment',
    validateAdjustReasonRequired: 'Kailangan ang dahilan ng adjustment',
    validateAdjustTypeRequired: 'Kailangan ang uri ng adjustment',
    validateBankCardNumber: 'Numero lamang ang tinatanggap para sa bank card number',
    validateCommission: 'Ang komisyon ay dapat nasa pagitan ng 0 at 1',
    validateNumberOnly: 'Numero lamang ang ilagay',
    validateNumberMoreThanOne: 'Pakilagay ang numerong higit sa 1',
    validateRevenueShare: 'Ang revenue share ay dapat nasa pagitan ng 0 at 1',
    validateUsdtWallet: 'Letra at numero lamang ang tinatanggap para sa USDT wallet',
    validateEwallet: 'Numero lamang ang tinatanggap para sa e-Wallet number',
    withdrawalToday: 'Withdrawal Ngayon',
    inputUSDTAmount: 'Pakilagay ang halaga ng USDT',
    inputAmount: 'Pakilagay ang halaga',
    selectAmount: 'Pumili ng halaga',
    minDepositeAmount: 'Minimum na deposito',
    maxDepositeAmount: 'Maximum na deposito',
    currencyRates: 'Rates ng Currency',
    understand: 'Nauunawaan',
    DepositCompleted: 'Nakumpleto',
    depositNotification1:
      "Ire-redirect ka sa page ng iyong bangko upang kumpletuhin ang deposito.",
    depositNotification2:
      'Kung matagumpay, makakatanggap ka ng notification sa page na ito.',
    validateTagDescriptionRequired: 'Kailangan ang description ng tag',
    confirmDelete:
      'Kumpirmahin na gusto mong tanggalin ang data na ito; hindi na maibabalik ang operasyon.',
    remarkMessage: 'Pakilagay ang remark ng miyembro sa loob ng 200 character.',
    validateTagDescriptionLength: 'Ang haba ng tag description ay dapat 1 hanggang 10',
    packRequestInQueue: 'Nasa pila ang iyong channel pack request',
    channelPackCancelSuccess: 'Matagumpay na nakansela ang iyong channel pack',
    channelPackUrlCopied: 'Nakopya ang Channel Pack URL sa clipboard.',
    validateAppNameRequired: 'Kailangan ang pangalan ng app',
    validateAppIconRequired: 'Kailangan ang icon ng app',
    validateShareRatioFormat: 'Ang share ratio ay dapat nasa pagitan ng 0 at 1',
    depositShouldBetween: 'Ang halaga ng deposito ay dapat nasa pagitan ng ',
    requiredPositiveInteger: 'Kailangan ng Positive Integer',
    cannotTransferToSelf: 'Hindi maaaring maglipat sa sarili mo',
    startEndMoreThanOneMonth: 'Ang start at end date ay hindi maaaring lampas sa isang buwan',
  },
  menu: {
    undefined: '',
    Dashboard: 'Pangunahing Pahina',
    'Downline Info': 'Impormasyon ng Downline',
    Member: 'Miyembro',
    Affiliate: 'Affiliate',
    AffiliateSummary: 'Buod ng Affiliate',
    gameRecord: 'Record ng Laro',
    financeCentre: 'Sentro ng Pananalapi',
    'Bet Record': 'Record ng Taya ng Miyembro',
    'Deposit Record': 'Record ng Deposito ng Miyembro',
    Statistics: 'Estadistika',
    'Game Stats': 'Stats ng Laro',
    'Affiliate Daily Report': 'Pang-araw-araw na Ulat ng Affiliate',
    'Affiliate Center': 'Sentro ng Affiliate',
    Deposit: 'Deposito',
    'Bind Bank Cards': 'I-bind ang Bank Cards',
    'Bank Withdrawal': 'Pag-withdraw sa Bangko',
    Transfer: 'Paglipat',
    'Referral Centre': 'Sentro ng Referral',
    'Referral Management': 'Pamamahala ng Referral',
    'Referral Link': 'Link ng Referral',
    'Referral Material': 'Materyal sa Referral',
    'Affiliate Domain': 'Domain ng Affiliate',
    'Personal Center': 'Personal na Sentro',
    'Settlement Center': 'Sentro ng Settlement',
    'Finance Report': 'Ulat sa Finance',
    'Settlement Report': 'Ulat ng Settlement',
    'Channel Pack': 'Pakete ng Channel',
    contactUs: 'Makipag-ugnayan sa Amin',
    'Daily Detail': 'Pang-araw-araw na Detalye',
    'Daily Summary': 'Pang-araw-araw na Buod',
    Withdraw: 'Mag-withdraw',
    'Rebate Report': 'Ulat ng Rebate',
    AffiliateOwnSummary: 'Sariling Buod ng Affiliate',
    'Retention Report': 'Ulat ng Retention',
  },
  posterType: {
    OVERALL: 'Kabuuang Referral',
    APP: 'APP Referral',
    SPONSOR: 'Sponsor Referral',
    GIFT: 'Gift Referral',
    COMPETITION: 'Competition Referral',
    EVENT: 'Event Referral',
    CRYPTO: 'Crypto Referral',
    AFFILIATE: 'Benepisyo ng Affiliate',
  },
  packStatus: {
    IN_QUEUE: 'Nasa Pila',
    IN_PROGRESS: 'Kasalukuyang Ginagawa',
    SUCCESS: 'Matagumpay',
    FAIL: 'Nabigo',
    CANCEL: 'Kanselahin',
  },
  appType: {
    ALL_SITE: 'ALL SITE',
    SPORT: 'SPORT',
    ESPORT: 'ESPORT',
  },
  member: {
    status: {
      normal: 'NORMAL',
      frozen: 'FROZEN',
    },
  },
  affiliate: {
    level: {
      JUNIOR_AFFILIATE: 'Junior Affiliate',
      SUB_AFFILIATE: 'Sub Affiliate',
      AFFILIATE: 'Affiliate',
      SUPER_AFFILIATE: 'Super Affiliate',
      MASTER_AFFILIATE: 'Master Affiliate',
      CHIEF_AFFILIATE: 'Chief Affiliate',
    },
    status: {
      APPLY: 'Mag-apply',
      NORMAL: 'Normal',
      DISABLE: 'I-disable',
    },
  },
  osType: {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
  },
  affiliateShareRatio: {
    AGENT_SHARE_BET_RATIO_FISH: 'Bet Ratio-FISH',
    AGENT_SHARE_BET_RATIO_SLOT: 'Bet Ratio-SLOT',
    AGENT_SHARE_BET_RATIO_ESPORT: 'Bet Ratio-ESPORT',
    AGENT_SHARE_BET_RATIO_LIVE: 'Bet Ratio-LIVE',
    AGENT_SHARE_BET_RATIO_SPORT: 'Bet Ratio-SPORT',
    "AGENT_SHARE_BET_RATIO_SPORT-LIVE-POKER": 'Bet Ratio-SPORT/LIVE/POKER',
    AGENT_SHARE_BET_RATIO_LOTTERY: 'Bet Ratio-LOTTERY',
    AGENT_SHARE_PROFIT_RATIO_FISH: 'Profit Ratio-FISH',
    AGENT_SHARE_PROFIT_RATIO_SLOT: 'Profit Ratio-SLOT',
    AGENT_SHARE_PROFIT_RATIO_ESPORT: 'Profit Ratio-ESPORT',
    AGENT_SHARE_PROFIT_RATIO_LIVE: 'Profit Ratio-LIVE',
    AGENT_SHARE_PROFIT_RATIO_SPORT: 'Profit Ratio-SPORT',
  },
  error: {
    400: 'Maling Request',
    403: 'Bawal',
    405: 'Hindi Pinapayagang Method',
    500: 'System Error',
    501: 'Duplicate Request ID',
    502: 'Hindi Nahanap ang Server',
    504: 'Masyadong Madalas ang Request',
    601: 'Error sa token verification',
    602: 'Nag-expire na ang token',
    603: 'Nawawala ang token',
    604: 'Naka-login na ang account',
    608: 'Masyadong madalas ang aksyon. Subukan muli',
    707: 'Hindi sapat ang balanse',
    709: 'Hindi sapat ang balanse ng komisyon',
    800: 'Error sa captcha verification',
    801: 'Nag-expire na ang captcha code',
    901: 'Hindi umiiral ang affiliate record',
    902: 'Ang miyembro ay hindi affiliate',
    903: 'Ang account ay affiliate',
    904: 'Ang account ay miyembro',
    905: 'Hindi pa naka-set ang tunay na pangalan',
    1000: 'Mali ang login name o password',
    1001: 'Naka-disable ang login account',
    1100: 'Hindi maaaring kapareho ng lumang password ang bagong password',
    1101: 'Mali ang lumang password',
    1102: 'Mali ang withdraw password',
    1200: 'Hindi naka-set ang security question',
    1201: 'Mali ang sagot',
    1303: 'Pansamantalang naka-block ang aksyon',
    1306: 'Lumampas sa maximum na bilang ng withdrawals para ngayong araw',
    1307: 'Lumampas sa daily withdrawal amount limit',
    1308: 'Hindi sapat ang balanse',
    1311: 'Huwag magsumite ng parehong withdrawal amount sa loob ng 24 oras',
    1313: 'Hindi sapat ang rollover, hindi makapag-withdraw',
    1319: 'Ang card number na ito ay na-bind na nang higit sa 2 beses at hindi na maaaring i-bind muli',
    11018: 'May hindi pa na-settle na komisyon. Hindi maaaring mag-withdraw.',
    13000: 'Hindi umiiral ang domain name',
    14000: 'Duplicate login name: ',
    14001: 'Duplicate phone number: ',
    14002: 'Duplicate email: ',
    14003: 'Hindi umiiral ang affiliate code: ',
    14004: 'Ang affiliate code ay hindi kabilang sa site na ito: ',
    14005: 'Ang komisyon ng affiliate ay dapat mas mababa kaysa sa komisyon ng superior affiliate: ',
    14006: 'Ang revenue ng affiliate ay dapat mas mababa kaysa sa revenue ng superior affiliate: ',
    14007: 'Hindi pa naaaprubahan ang affiliate application',
    14008: 'Ang komisyon ng affiliate ay dapat mas mataas kaysa sa komisyon ng child affiliate: ',
    14009: 'Ang revenue ng affiliate ay dapat mas mataas kaysa sa revenue ng child affiliate: ',
    14100: 'Ang miyembrong ito ay hindi mo downline member',
    14101: 'Walang pribilehiyo ang affiliate para i-settle ang settlement na ito',
    14102: 'Umiiral na ang member tag',
    14103: 'Lumampas sa limit ng member tag',
    14104: 'Lumampas sa limit ng member tag',
    14105: 'Ang login name ay maaari lamang binubuo ng letra at numero',
    14106: 'Mali ang password',
    14107: 'Mali ang uri ng paglipat',
    14109: 'Hindi maaaring maglipat sa sarili mo',
    15010: 'Ang miyembrong ito ay hindi mo downline member',
    15201: 'Mali ang lumang password',
    15202: 'Hindi maaaring kapareho ng lumang password ang bagong password',
    24000: 'Nabigo ang Verification',
    1009: 'Mali ang Google authentication code',
    900: 'Hindi umiiral ang account',
    11000: 'Hindi umiiral ang affiliate',
    11001: 'Naka-maintenance ang deposit platform',
    11002: 'Wala sa range ang halaga ng deposito',
    11003: 'Error sa halaga ng deposito',
    11004: 'Hindi nahanap ang deposit privilege',
    11005: 'Error sa WorldPay deposit',
    11011: 'Hindi naka-set ang superior share ratio',
    11012: 'Hindi naka-set ang superior share ratio para sa uri ng laro: ',
    11013: 'Hindi maaaring lumampas ang affiliate share ratio sa superior ratio',
    11014: 'Hindi maaaring lumampas ang kabuuang affiliate share ratio para sa lahat ng downline sa superior affiliate share ratio',
    11015: 'Hindi naka-set ang affiliate share ratio',
    11016: 'Hindi maaaring lumampas ang member share ratio sa affiliate share ratio',
    12104: 'Frozen ang miyembro, hindi makapag-withdraw',
    12105: 'Ang iyong operasyon sa withdrawal ay may network delay, na nagreresulta sa pagkabigo ng pagbabayad. Mangyaring maghintay ng 30 minuto bago mag-withdraw muli, salamat!',
    14012: 'Maaari lamang gumawa ng affiliate na mas mababa ang antas',
    14013: 'May downline ang affiliate, hindi maaaring ibaba ang antas',
    14014: 'Mali ang format ng phone',
    17000: 'Invalid na uri ng file',
    17001: 'Nabigo ang file upload',
    20300: 'Nag-expire na ang key, i-refresh ang page at subukan muli',
    20301: 'Pakilagay ang Google Authentication Code',
    25000: 'Hindi suportadong operasyon',
  },
}
